'use client'

import { Button } from '@/components'
import { useTranslations } from 'next-intl'

interface Props {
  onAcceptAll: () => void
  onSettingsClick: () => void
}

const CookieBar = ({ onAcceptAll, onSettingsClick }: Props) => {
  const t = useTranslations('cookieConsent.cookieBar')

  return (
    <div className="fixed max-w-[600px] m-auto z-50 flex flex-col items-center gap-4 p-4 bg-primary shadow-xl bottom-4 left-4 right-4 md:left-8 md:right-8 rounded-xl md:flex-row text-white">
      <div className="flex-1 text-sm text-white">
        {t('text')}{' '}
        <Button
          variant="link"
          className="text-white underline"
          size="sm"
          onClick={onSettingsClick}
        >
          {t('settings')}
        </Button>
      </div>
      <Button
        variant="glow"
        className="text-primary font-bold"
        size="lg"
        onClick={onAcceptAll}
      >
        {t('accept')}
      </Button>
    </div>
  )
}

export default CookieBar
